import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminService from "../services/AdminService";
export const AdminAuthContext = createContext({
    adminData: {},
    logOut: () => {},
    getData: () => {}
});
export default function AdminAuthProvider({ children }) {
    const [adminData, setAdminData] = useState({});
    const navigate = useNavigate();
    const getData = () => {
        AdminService.getUserData().then((res) => {
            if (res && res.data) {
                setAdminData({
                    firstName: res.data.firstName || "",
                    lastName: res.data.lastName || "",
                    userName: res.data.userName || "",
                    iaAdmin: res.data.isAdmin,
                    email: res.data.email || "",
                    lastLogIn: res.data.lastLogIn || ""
                });
            } 
            else {
                setAdminData({});
            }
        })
        .catch(() => {
            setAdminData({});
        });
    };
    useEffect(() => {
        getData();
    }, []);
    const logOut = async () => {
        try {
            await AdminService.logOut();
        } 
        catch (error) {
            if (error.response?.status === 401) {
                console.warn("User was already logged out.");
            } 
            else {
                console.error("Logout error:", error);
            }
        } 
        finally {
            setAdminData({});
            navigate("/");
        }
    };
    return (
        <AdminAuthContext.Provider value={{ adminData, logOut, getData }}>
            {children}
        </AdminAuthContext.Provider>
    );
}
